import {arc} from '../path/shapes.js';
import markItemPath from './markItemPath.js';

export default markItemPath('arc', arc);
